<template>
  <div class="page-profits">
    <Navigation :title="pageTitle" />
    <div class="tabs-wrap" v-if="pageType === 3">
      <md-tab-bar v-model="curState" :items="tabList" :maxLength="tabList.length" :ink-length="30" @change="handleChangeTab" />
    </div>
    <div class="profit-tab-wrap" v-else>
      <div
        class="profit-tab-item"
        :class="{ current: curState === item.name }"
        v-for="(item, index) in tabList"
        :key="item.name"
        @click="handleChangeProfitTab(item, index)"
      >
        <div class="label">{{ item.label }}</div>
        <div class="desc">¥{{ item.value }}</div>
      </div>
    </div>
    <!-- 骨架屏 -->
    <div class="skeleton-list" v-if="showProfitListSkeleton">
      <md-skeleton class="skeleton-item" v-for="item in 5" :key="item" avatar title :row="2" :loading="showProfitListSkeleton"></md-skeleton>
    </div>
    <!-- 订单列表 -->
    <div class="profit-list-wrap" v-show="profitListData.total_count > 0" :style="{ top: pageType === 3 ? '1.58rem' : '1.8rem' }">
      <md-scroll-view ref="scrollView" :scrolling-x="false" @refreshing="onPullingDownRefresh" @end-reached="onPullingUp">
        <md-scroll-view-refresh
          slot="refresh"
          slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
          :scroll-top="scrollTop"
          :is-refreshing="isRefreshing"
          :is-refresh-active="isRefreshActive"
        ></md-scroll-view-refresh>
        <div class="profit-list">
          <ProfitItem
            :isBean="pageType === 3"
            :item="beanItem"
            v-for="(beanItem, index) in profitListData.data"
            :key="`${index}_${beanItem.orderCode}}`"
          />
        </div>
        <md-scroll-view-more slot="more" :is-finished="!showProfitListSkeleton && !profitListData.loadMore"></md-scroll-view-more>
      </md-scroll-view>
    </div>
    <md-result-page
      style="margin-top:-2rem;"
      type="empty"
      text="还没有数据~"
      v-show="!showProfitListSkeleton && !profitListData.loadMore && profitListData.total_count === 0"
    ></md-result-page>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import ProfitItem from '@/components/profitItem'
import { TabBar, ScrollView, ScrollViewRefresh, ScrollViewMore, ResultPage, Skeleton } from 'mand-mobile'
import { getPageData } from '@/utils/help'
// const beanItem = {
//   orderCode: '558580839385085599',
//   mobile: '186****6682',
//   num: 27,
//   crtTime: '2019-11-07 15:53:26',
//   enrolledTime: '2019-10-28 01:06:22',
// }
export default {
  name: 'goldenBeans',
  components: {
    Navigation,
    ProfitItem,
    [TabBar.name]: TabBar,
    [Skeleton.name]: Skeleton,
    [ResultPage.name]: ResultPage,
    [ScrollView.name]: ScrollView,
    [ScrollViewRefresh.name]: ScrollViewRefresh,
    [ScrollViewMore.name]: ScrollViewMore,
  },
  data() {
    return {
      channel: '',
      pageTitle: '',
      pageType: 1, // 1:已结算收益 2:待结算收益 3:我的金豆
      curState: 0, // 待结算收益,已结算收益(0:今日 1:本月 2:上月 3:全部), 我的金豆(0:未结算 1:已结算)
      tabList: [],
      showProfitListSkeleton: true,
      profitListData: {
        currentPage: 1,
        pageSize: 20,
        total_count: 0,
        loadMore: true,
        data: [],
      },
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.channel = this.$route.query.channel || 'tbk'
      this.pageType = parseInt(this.$route.query.type || 1)
      this.curState = parseInt(this.$route.query.state || 0)
      if (this.pageType === 1 || this.pageType === 2) {
        // 已结算收益,待结算收益
        this.tabList = [
          { name: 0, label: '全部', key: 'money', value: '' },
          { name: 1, label: '今日', key: 'todayMoney', value: '' },
          { name: 2, label: '本月', key: 'currMoney', value: '' },
          { name: 3, label: '上月', key: 'lastMoney', value: '' },
        ]
        this.pageTitle = this.pageType === 1 ? '已结算收益' : '待结算收益'
      } else if (this.pageType === 3) {
        // 我的金豆
        this.tabList = [
          { name: 0, label: '待结算', key: 'unbookedMoney', value: '' },
          { name: 1, label: '已结算', key: 'enrolledMoney', value: '' },
        ]
        this.pageTitle = '我的金豆'
      }
      this.fetchProfitBalance()
      this.fetchProfitList(1)
    },
    /**
     * 加载收益账户数据
     */
    fetchProfitBalance() {
      let promise
      if (this.pageType === 1) {
        // 已结算收益
        promise = this.$http[this.channel].settledProfitBalance()
      } else if (this.pageType === 2) {
        // 待结算收益
        promise = this.$http[this.channel].unsettledProfitBalance()
      } else if (this.pageType === 3) {
        // 我的金豆
        console.log('api', this.$http[this.channel])
        promise = this.$http[this.channel].beanBalance()
      }
      promise.then(res => {
        for (let item of this.tabList) {
          item.value = res.data[item.key]
          if (this.pageType === 3) {
            item.label = `${item.label} ${item.value}`
          }
        }
      })
    },
    /**
     * 下拉刷新
     */
    onPullingDownRefresh() {
      this.fetchProfitList(1, true)
    },
    /**
     * 加载更多
     */
    onPullingUp() {
      if (this.profitListData.loadMore) {
        this.fetchProfitList(this.profitListData.currentPage + 1)
      }
    },
    /**
     * 切换tab时重置列表数据
     */
    resetListData() {
      this.profitListData.currentPage = 1
      this.profitListData.pageSize = 10
      this.profitListData.total_count = 0
      this.profitListData.loadMore = true
      this.profitListData.data = []
      this.resetScroll()
    },
    /**
     * 重置滚动器
     */
    resetScroll() {
      const scrollVM = this.$refs.scrollView
      if (scrollVM) {
        scrollVM.scrollTo(0, 0, false)
      }
    },
    /**
     * 切换收益tab
     */
    handleChangeProfitTab(item) {
      if (item.name !== this.curState) {
        this.handleChangeTab(item)
      }
    },
    /**
     * 切换tab
     */
    handleChangeTab(item) {
      this.curState = item.name
      this.resetListData()
      this.fetchProfitList(1)
    },
    /**
     * 收益列表
     */
    fetchProfitList(currentPage, isPullingDownRefresh) {
      if (currentPage === 1) {
        this.showProfitListSkeleton = true
      }
      let promise
      if (this.pageType === 1) {
        // 已结算收益
        promise = this.$http[this.channel].settledProfitList(this.curState, currentPage)
      } else if (this.pageType === 2) {
        // 待结算收益
        promise = this.$http[this.channel].unsettledProfitList(this.curState, currentPage)
      } else if (this.pageType === 3) {
        // 我的金豆
        promise = this.$http[this.channel].beanList(this.curState, currentPage)
      }
      promise
        .then(res => {
          this.profitListData = getPageData(currentPage, this.profitListData, res)
          if (isPullingDownRefresh || currentPage === 1) {
            // 下拉刷新
            this.$refs.scrollView.finishRefresh()
            this.$refs.scrollView.finishLoadMore() // 重置加载更多
          }
          if (currentPage > 1) {
            // 加载更多
            this.$refs.scrollView.finishLoadMore()
          }
          this.showProfitListSkeleton = false
          this.$nextTick(() => {
            this.$refs.scrollView.reflowScroller()
          })
        })
        .catch(() => {
          this.showProfitListSkeleton = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-profits {
  position: relative;
  height: 100%;
  background: #fff;
  .tabs-wrap {
    height: 0.7rem;
    box-shadow: 0 0 0.2rem 0.01rem hsla(0, 0%, 85%, 0.34);
  }
  .profit-tab-wrap {
    position: relative;
    display: flex;
    height: 0.92rem;
    background: #fff;
    z-index: 2;
    &::before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      right: 0;
      height: 0.01rem;
      background: #eeefef;
      transform: scaleY(0.5);
      z-index: 3;
    }
    &::after {
      position: absolute;
      content: '';
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: #eeefef;
    }
    .profit-tab-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 0.92rem;
      padding: 0.08rem 0;
      flex: 1;
      color: #444654;
      font-size: 0.26rem;
      background: #fff;
      cursor: pointer;
      &:active {
        opacity: 0.5;
      }
      &:not(:last-child):after {
        position: absolute;
        content: '';
        top: 0.23rem;
        bottom: 0.23rem;
        right: 0;
        width: 0.02rem;
        background: #eee;
      }
      &.current {
        color: rgba(255, 30, 50, 1);
        font-weight: bold;
        &:before {
          position: absolute;
          content: '';
          bottom: 0;
          left: 25%;
          right: 25%;
          height: 0.04rem;
          border-radius: 1rem;
          width: 50%;
          background: rgba(255, 30, 50, 1);
          z-index: 3;
        }
        .desc {
          color: rgba(255, 30, 50, 1);
        }
      }
      .label {
        line-height: 0.4rem;
      }
      .desc {
        line-height: 0.36rem;
        color: #999;
      }
    }
  }
  .skeleton-list {
    background: #fff;
    padding: 0.4rem;
  }
  .profit-list-wrap {
    position: absolute;
    top: 1.58rem;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    .profit-list {
      padding: 0.12rem 0.2rem;
    }
  }
}
</style>
